import './base/';
import './base/sliders';
import './base/ajax-cart';
import './base/parallax';
import './base/in-view';
import './base/responsive-images';
import './base/accordions';
import './base/nav-category';
import './base/blog-infinity-load';
import './base/newsletter-popup';
import './base/sticky-head';
import './base/sticky-internet-explorer';
import './base/mobile-nav';
import './base/body-target';
import './base/products-recommended';
import './base/products-recent';
import './base/toggle-buttons';
import './base/btn-scroll';
import './base/options';

const $win = $(window);
const $doc = $(document);

$doc.on('click', '.cs-options li', function() {
	location.reload();
});

if ($('.header__bar').length) {
	$('.wrapper').addClass('has-header-bar');
}

$win.on('load', function() {
	if ($('.rf-widget').length > 0) {
		let targetNode = document.querySelector('.rf-widget');

		if (targetNode) {
			let config = { childList: true };
			let callback = function(mutationsList, observer) {
				for (let mutation of mutationsList) {
					if (mutation.type == 'childList') {
						const element = $('.rf-widget').find('.rf-input');
						element.attr('id', 'email1');
						element.parent().attr('for', 'email1');
					}
				}
			};

			let observer = new MutationObserver(callback);
			observer.observe(targetNode, config);
		}
	}
});


radioVariantsSelect($('.radio-variant'), $('#product-select'))

function radioVariantsSelect($radio, $productSelect) {
	$radio.each(function(event) {
		const $this 				= $(this);
		const $input 				= $this.find('input');
		const inputID 			= $input.attr('id');
		const variantValue 	= inputID.split('field-')[1];

		$input.on('click', function() {
			$productSelect.find('option:selected').removeAttr("selected");
			$productSelect.find(`option[value=${variantValue}]`).attr('selected', 'selected').trigger('change');
		});
	});
}

clickEvent($('.js-click-trigger'), 'open');

clickEvent($('.js-filter-trigger'), 'open', $('.collection-overlay'));

/**
 * simple click event
 * @param  {jQuery selector} $trigger
 * @param  {string} activeClass
 * @return {void}
 */
function clickEvent($trigger, activeClass, $dependingElement) {
	$trigger.on('click', function(event) {
		event.preventDefault();

		const $this 		= $(this);
		const $target 	= $($this.data('target'));

		if ($dependingElement) {
			$dependingElement.toggleClass(activeClass);
		}

		$target.add($this).toggleClass(activeClass);
	});
}

collectFilters();

function collectFilters() {
	$('.collection__options ul').empty();
	
	$('.filter__option').each(function() {
		const $this 					= $(this);
		const $activeFilter 	= $this.find('li.current');
		const $element 				= $activeFilter.clone();

		$('.collection__options ul').append($element);

		$('.collection__options ul li').find('a.js-filter-option').removeClass('js-filter-option').addClass('item');
	});

	setTimeout(function() {
		$('.collection__options ul li').append('<a href="#" class="clear-item"></a>');

		const optionsSize = $('.collection__options ul li').length;

		if (optionsSize < 1) {
			$('.collection__options').hide();
		};
	}, 10);

	
	$doc.on('click', '.clear-item', function(event) {
		const $this 			= $(this);
		const $parent 		= $this.closest('li');
		const $item 			= $parent.find('.item')
		const itemHref 		= $item.attr('href');
		const newHref 		= window.location.href.replace(itemHref, '');
		const newHrefFix 	= newHref.replace('++', '+').replace('/+', '/')

		event.preventDefault();

		window.location = newHrefFix;
	})
}
